import { render, staticRenderFns } from "./ItinerariesEmptyState.vue?vue&type=template&id=1d23934e"
import script from "./ItinerariesEmptyState.vue?vue&type=script&lang=js"
export * from "./ItinerariesEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports